export function formatDate(date) {
	const options = { day: '2-digit', month: 'long', year: 'numeric' };
	return new Date(date).toLocaleDateString('en-GB', options);
}

export const setFuelTypes = (selectedFuelType, search) => {
	const fuelTypeSelect = document.getElementsByName('fuelTypeSelect'),
		fuelTypeSelectSort = document.getElementsByName('fuelTypeSelectSort');
	if (search === 'search') {
		fuelTypeSelect.forEach(fuelType => {
			if (fuelType.checked) {
				selectedFuelType = fuelType.value;
			}
		});

		fuelTypeSelectSort.forEach(fuelType => {
			if (fuelType.value == selectedFuelType) {
				fuelType.checked = true;
			}
		});
	} else if (search === 'initial') {
		fuelTypeSelect[0].checked = true;
	} else {
		fuelTypeSelectSort.forEach(fuelType => {
			if (fuelType.checked) {
				selectedFuelType = fuelType.value;
			}
		});
		fuelTypeSelectSort.forEach(fuelType => {
			if (fuelType.value == selectedFuelType) {
				fuelType.checked = true;
			}
		});
	}

	return selectedFuelType;
};

export const setPostCode = (postCodeField, selectedPostCode) => {
	postCodeField.placeholder = selectedPostCode;
	postCodeField.value = selectedPostCode;
};

export const setRadius = (radius, expand) => {
	const radiusSelect = document.getElementsByName('searchRadius');

	if (expand) {
		let checkedIndex = -1;
		// Find the index of the currently checked radio button
		for (let i = 0; i < radiusSelect.length; i++) {
			if (radiusSelect[i].checked) {
				checkedIndex = i;
				break;
			}
		}

		if (checkedIndex < radiusSelect.length - 1) {
			radiusSelect[checkedIndex + 1].checked = true;
			radius = radiusSelect[checkedIndex + 1].value;
		}
	} else {
		radiusSelect.forEach(radiusSelected => {
			if (radiusSelected.checked) {
				radius = radiusSelected.value;
			}
		});
	}

	return radius;
};

export const setSort = sortType => {
	const sortSelect = document.getElementsByName('sortBy');
	sortSelect.forEach(sortSelected => {
		if (sortSelected.checked) {
			sortType = sortSelected.value;
		}
	});

	return sortType;
};

export const errorValidation = (location, error) => {
	if (location === null) return false;
	const fieldGroup = location.closest('.field-group');
	const locationGroup = location.previousElementSibling;
	const validationGroup = locationGroup.previousElementSibling;
	const postCodeRegex = /^[a-zA-Z]{1,2}\d[a-zA-Z\d]?\s*\d[a-zA-Z]{2}$/;

	if (fieldGroup) {
		if (location.value === '' || location.value === undefined || !postCodeRegex.test(location.value)) {
			fieldGroup.classList.add('field-group--error');
			validationGroup.classList.remove('display-none');
			fieldGroup.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
			return false;
		} else if (error) {
			fieldGroup.classList.add('field-group--error');
			locationGroup.classList.remove('display-none');
			fieldGroup.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		} else {
			fieldGroup.classList.remove('field-group--error');
			return true;
		}
	}
	return false;
};

export const setupShowMoreOptions = () => {
	const showMoreOptionsCSSClass = 'show-more-link';

	const showMoreOptionLinks = document.querySelectorAll(`.${showMoreOptionsCSSClass}`);

	showMoreOptionLinks.forEach(function (showMoreOptionLink) {
		showMoreOptionLink.addEventListener('click', e => {
			e.preventDefault();
			showMoreOptionLink.remove();
		});
	});
};

export async function getLatLng(selectedPostCode) {
	return new Promise((resolve, reject) => {
		// Create a Geocoder instance
		const geocoder = new google.maps.Geocoder();

		// Perform geocoding
		geocoder.geocode({ address: selectedPostCode }, function (results, status) {
			if (status === 'OK' && results[0].geometry) {
				const location = results[0].geometry.location;
				const lat = location.lat();
				const long = location.lng();
				resolve({ lat, long });
			} else {
				console.error('Geocoding failed:', status);
				reject(status);
			}
		});
	});
}

export function setSessionCookie(name, value) {
	document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
}

export function cookieExists(name) {
	// Get all cookies
	const cookies = document.cookie.split(';');

	// Iterate through each cookie to check if it matches the name
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();

		// Check if the cookie starts with the specified name
		if (cookie.startsWith(`${name}=`)) {
			return true; // Cookie exists
		}
	}

	return false; // Cookie doesn't exist
}

export function deleteCookie(name) {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function scrollToTop() {
	window.scrollTo({
		top: 0,
		behavior: 'smooth', // Optional: animated smooth scroll
	});
}
